// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Smh-","fullView":"styles_fullView__2tmTG"};